export default function CircleAddedIcon({ className = "", onClick = null }) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
    >
      <path d="M384.35,115.65c-17.94-17.94-38.85-31.85-61.6-41.28-22.76-9.43-47.38-14.37-72.75-14.37-50.75,0-98.47,19.77-134.35,55.65-35.88,35.88-55.65,83.6-55.65,134.35s19.77,98.47,55.65,134.35c35.88,35.88,83.6,55.65,134.35,55.65s98.47-19.77,134.35-55.65c35.88-35.88,55.65-83.6,55.65-134.35s-19.77-98.47-55.65-134.35ZM347.08,206.08l-136.58,136.58-60.58-60.58c-7.23-7.22-7.23-18.94,0-26.16,7.22-7.23,18.94-7.23,26.16,0l34.42,34.42,110.42-110.42c7.22-7.23,18.94-7.23,26.16,0,7.23,7.22,7.23,18.94,0,26.16Z"/>
    </svg>
  );
}
